import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonAnimations } from '@shared/animations/common.animations';
import {
  AxialRotaryDialButton,
  RotaryDialButton,
} from '@features/client/order-workflow/models/rotary-dial-button.model';
import { RotaryDialAnimations } from '@features/client/order-workflow/components/rotary-dial/rotary-dial.animations';
import { Tooth } from '@features/client/order-workflow/models/tooth.model';
import { ClickOutsideDirective } from '@capturum/ui/api';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-rotary-dial',
  animations: [RotaryDialAnimations.main, CommonAnimations.fadeIn],
  templateUrl: 'rotary-dial.component.html',
  styleUrls: ['rotary-dial.component.scss'],
  imports: [ClickOutsideDirective, Tooltip],
})
export class RotaryDialComponent implements OnChanges {
  @Input() public buttons: RotaryDialButton[] = [];
  @Input() public tooth: Tooth;
  @Output() public closeDial: EventEmitter<void> = new EventEmitter<void>();

  public isOpened: boolean = false;
  public disableTooltip: boolean = false;
  public dialButtons: AxialRotaryDialButton[] = [];

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.buttons) {
      this.dialButtons = this.distributeDialButtons(changes.buttons.currentValue);

      setTimeout(() => {
        return (this.isOpened = true);
      }, 1);
      setTimeout(() => {
        return (this.disableTooltip = false);
      }, 200);
    }
  }

  public onDialButtonClick(dialButton: RotaryDialButton): void {
    if (dialButton.onClick) {
      dialButton.onClick(this.tooth);
    }

    this.toggle();
  }

  public toggle(): void {
    this.isOpened = !this.isOpened;

    if (this.isOpened) {
      setTimeout(() => {
        return (this.disableTooltip = false);
      }, 200);
    } else {
      this.disableTooltip = true;
    }
  }

  public close(): void {
    this.isOpened = false;
    this.disableTooltip = true;

    this.closeDial.emit();
  }

  /**
   * Calculate the even distribution of the buttons in the circular position.
   */
  private distributeDialButtons(currentDialButtons: RotaryDialButton[]): AxialRotaryDialButton[] {
    const distributedDialButtons: AxialRotaryDialButton[] = [];
    const totalButtons = currentDialButtons ? currentDialButtons.length : 0;

    for (let index = 0; index < totalButtons; index++) {
      distributedDialButtons.push({
        ...currentDialButtons[index],
        x: this.calculateButtonAxle('x', totalButtons, index),
        y: this.calculateButtonAxle('y', totalButtons, index),
      });
    }

    return distributedDialButtons;
  }

  private calculateButtonAxle(type: 'x' | 'y', totalButtons: number, currentIndex: number): number {
    const deg2rad = (digit: number) => {
      return digit * (Math.PI / 180);
    };
    const method = type === 'x' ? Math.cos : Math.sin;

    return Math.round(method(deg2rad((360 / totalButtons) * currentIndex - 90)) * (totalButtons * 3.2 + 40));
  }
}
